var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIconActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6499 20.625C21.5841 20.739 21.4894 20.8337 21.3753 20.8995C21.2613 20.9654 21.1319 21 21.0002 21H3.00021C2.86862 20.9999 2.73938 20.9651 2.62548 20.8992C2.51157 20.8333 2.417 20.7386 2.35127 20.6247C2.28553 20.5107 2.25094 20.3814 2.25098 20.2498C2.25101 20.1182 2.28566 19.9889 2.35146 19.875C3.77927 17.4065 5.97958 15.6365 8.54739 14.7975C7.27724 14.0414 6.29041 12.8892 5.73845 11.5179C5.18648 10.1467 5.09991 8.63211 5.49203 7.20688C5.88414 5.78165 6.73326 4.52454 7.90898 3.6286C9.0847 2.73266 10.522 2.24744 12.0002 2.24744C13.4784 2.24744 14.9157 2.73266 16.0914 3.6286C17.2672 4.52454 18.1163 5.78165 18.5084 7.20688C18.9005 8.63211 18.8139 10.1467 18.262 11.5179C17.71 12.8892 16.7232 14.0414 15.453 14.7975C18.0208 15.6365 20.2211 17.4065 21.649 19.875C21.7149 19.9889 21.7497 20.1182 21.7499 20.2499C21.7501 20.3815 21.7156 20.5109 21.6499 20.625Z",
    fill: "#9E3039"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIconActive);
export default __webpack_public_path__ + "static/media/user-icon-active.fde496c9322b737ea54d8e4f2a56b20e.svg";
export { ForwardRef as ReactComponent };